import { iPhoto, iPhotoSize } from './media'

export enum ContentType {
  text = 'messageText',
  sticker = 'messageSticker',
  document = 'messageDocument',
  photo = 'messagePhoto',
  voice = 'messageVoiceNote'
}

export enum ChatType {
  private = 'chatTypePrivate',
  group = 'chatTypeSupergroup'
}
export enum ChatAction {
  typing = 'chatActionTyping',
  cancel = 'chatActionCancel'
}

export interface iUnread {
  chat_id: number
  last_read_inbox_message_id: number
  unread_count: number
}

export interface iChatAction {
  action: {
    '@type':  ChatAction
  }
  chat_id: number
  user_id: number
}

export interface iMessageContent {
  '@type': ContentType
  text?: {
    entities: string[]
    text: string
  }
  sticker?: {
    emoji: string
    height: number
    is_animated: boolean
    is_mask: boolean
    set_id: string
  },
  photo: {
    has_stickers: boolean
    minithumbnail: {
      data: string
      height: number
      width: number
    }
    sizes: iPhotoSize[]
  }
}

export interface iMessage {
  author_signature: string
  can_be_deleted_for_all_users: boolean
  can_be_deleted_only_for_self: boolean
  can_be_edited: boolean
  can_be_forwarded: boolean
  chat_id: number
  contains_unread_mention: boolean
  content: iMessageContent
  date: number
  edit_date: number
  id: number
  is_channel_post: boolean
  is_outgoing: boolean
  media_album_id: string
  reply_to_message_id: number
  sender_user_id: number
  ttl: number
  ttl_expires_in: number
  via_bot_user_id: number
  views: number
}

export interface iChat {
  can_be_deleted_for_all_users: boolean
  can_be_deleted_only_for_self: boolean
  can_be_reported: boolean
  client_data: string
  default_disable_notification: boolean
  id: number
  is_marked_as_unread: boolean
  is_pinned: boolean
  is_sponsored: boolean
  last_read_inbox_message_id: number
  last_read_outbox_message_id: number
  notification_settings: {
    disable_mention_notifications: boolean
    disable_pinned_message_notifications: boolean
    mute_for: number
    show_preview: boolean
    sound: string
    use_default_disable_mention_notifications: boolean
    use_default_disable_pinned_message_notifications: boolean
    use_default_mute_for: boolean
    use_default_show_preview: boolean
    use_default_sound: boolean
  }
  order: string
  permissions: {
    can_add_web_page_previews: boolean
    can_change_info: boolean
    can_invite_users: boolean
    can_pin_messages: boolean
    can_send_media_messages: boolean
    can_send_messages: boolean
    can_send_other_messages: boolean
    can_send_polls: boolean
  }
  photo: {
    big: iPhoto
    small: iPhoto
  }
  pinned_message_id: number
  reply_markup_message_id: number
  title: string
  type: {
    '@type': ChatType
    user_id: number
    is_channel: boolean
    supergroup_id: number
  }
  unread_count: number
  unread_mention_count: number
}
